import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["agadir-taghazout-to-imsouane"];

export const Route = createFileRoute("/transfers/agadir-taghazout-to-imsouane")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
